import BaseService from './BaseService';

class MessagesService extends BaseService {
  /**
   * Fetch
   * @return {Promise} [description]
   */
  fetch = (what) => {
    // const config = { url: '/messages' };
    const config = { url: ['/messages', what].join('/') };
    return this.doRequest(config);
  };


  /**
   * Delete Message
   * @param  {Number} messageId
   * @return {Promise}
   */
  deleteMessage = (messageId = null) => {
    const config = {
      url: `/messages/deletemessage/${messageId}`,
      method: 'post',
    };
    return this.doRequest(config);
  };


  /**
   * Accpet Request
   * @param  {Number} invitationId
   * @return {Promise}
   */
  acceptInvitation = (invitationId = null) => {
    const config = {
      method: 'post',
      url: `/messages/acceptinvitation/${invitationId}`,
    };
    return this.doRequest(config);
  };


  /**
   * Reject Request
   * @param  {Number} invitationId
   * @return {Promise}
   */
  rejectInvitation = (invitationId) => {
    const config = {
      method: 'post',
      url: `/messages/rejectinvitation/${invitationId}`,
    };
    return this.doRequest(config);
  };


  /**
   * Cancel Invitation
   * @param  {Number} invitationId
   * @return {Promise}
   */
  cancelInvitation = (invitationId) => {
    const config = {
      method: 'post',
      url: `/messages/cancelinvitation/${invitationId}`,
    };
    return this.doRequest(config);
  };
}

export { MessagesService as default };
